/**
 * Yotpo Reviews – product page layout adjustments
 * Moves Write A Review button and review date between panels for desktop/mobile.
 * Attaches click-to-scroll from .yotpo-widget-instance to #yotpo-reviews-main-widget.
 * Used by sections/product-information.liquid.
 */
(function () {
  var boundScrollInstances = new WeakSet();

  /** @param {Element} instance */
  function hasZeroReviews(instance) {
    var btn = instance.querySelector(
      'button.yotpo-sr-bottom-line-button[aria-label*="total 0 reviews"]',
    );
    return Boolean(btn);
  }

  function openWriteReviewForm() {
    var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
    if (!reviewsWidget) return;
    var writeBtn = /** @type {HTMLElement|null} */ (
      reviewsWidget.querySelector('.yotpo-new-review-btn-wrapper .yotpo-new-review-btn')
    );
    if (!writeBtn) return;
    var btn = writeBtn;
    setTimeout(function () {
      btn.click();
    }, 600);
  }

  function attachScrollToReviews() {
    var instances = document.querySelectorAll('.yotpo-widget-instance');
    instances.forEach(function (instance) {
      if (boundScrollInstances.has(instance)) return;
      boundScrollInstances.add(instance);
      /** @type {HTMLElement} */ (instance).style.cursor = 'pointer';
      instance.addEventListener('click', function () {
        if (hasZeroReviews(instance)) {
          openWriteReviewForm();
          return;
        }
        var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
        if (reviewsWidget) {
          reviewsWidget.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }
  function moveYotpoReviewButton() {
    var summary = document.querySelector('.yotpo-bottom-line-summary');
    var btnWrapper = document.querySelector('.yotpo-new-review-btn-wrapper');
    if (summary && btnWrapper && summary.parentNode && summary.nextElementSibling !== btnWrapper) {
      summary.parentNode.insertBefore(btnWrapper, summary.nextSibling);
      return true;
    }
    return false;
  }

  function moveYotpoDateAboveQuestions() {
    if (window.innerWidth <= 1079) return false;
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var dateEl = review.querySelector('.yotpo-review-right-panel .yotpo-review-date');
      var questionsPanel = review.querySelector('.yotpo-review-questions-mobile-panel');
      if (dateEl && questionsPanel && !questionsPanel.contains(dateEl)) {
        questionsPanel.insertBefore(dateEl, questionsPanel.firstChild);
        moved++;
      }
    });
    return moved > 0;
  }

  function moveYotpoDateToRightPanel() {
    if (window.innerWidth > 1079) return false;
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var rightPanel = review.querySelector('.yotpo-review-right-panel');
      var dateEl = review.querySelector('.yotpo-review-questions-mobile-panel .yotpo-review-date');
      if (dateEl && rightPanel && !rightPanel.contains(dateEl)) {
        rightPanel.appendChild(dateEl);
        moved++;
      }
    });
    return moved > 0;
  }

  function runYotpoLayout() {
    moveYotpoReviewButton();
    if (window.innerWidth > 1079) {
      moveYotpoDateAboveQuestions();
    } else {
      moveYotpoDateToRightPanel();
    }
  }

  runYotpoLayout();
  attachScrollToReviews();
  var observer = new MutationObserver(function () {
    runYotpoLayout();
    attachScrollToReviews();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
    runYotpoLayout();
    attachScrollToReviews();
  }, 5000);
  window.addEventListener('resize', function () {
    runYotpoLayout();
  });
})();
